// src/hooks/hotelRoomCategories/useRestoreHotelRoomCategory.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreHotelRoomCategory as restoreHotelRoomCategoryAPI } from "../../api/apiHotelRoomCategories";
import parseError from "../../utils/parseError";

const useRestoreHotelRoomCategory = () => {
    const queryClient = useQueryClient();

    const { mutate: restore, isPending: isRestoring } = useMutation({
        mutationFn: restoreHotelRoomCategoryAPI,
        onSuccess: (res) => {
            const message = res?.message || "Hotel room category restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRoomCategories"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore hotel room category");
        },
    });

    return { restoreHotelRoomCategory: restore, isRestore: isRestoring };
};

export default useRestoreHotelRoomCategory;
